import React from 'react';

import './RecruitLink.css';

const recruitItems = [
    '歯科衛生士・新卒',
    '歯科衛生士・転職',
    '歯科助手',
];

function RecruitLink() {
    return (
        <div className="recruit-link-section">
            <div className="recruit-closed-notice" role="status">
                <i className="fas fa-info-circle"></i>
                <p>現在、全職種において募集を行っておりません。</p>
            </div>

            {recruitItems.map((item) => (
                <button
                    type="button"
                    className="recruit-disabled-btn"
                    disabled
                    aria-label={`${item}は現在募集を行っておりません`}
                    key={item}
                >
                    <span>
                        {item}
                    </span>
                    <span className="recruit-status-label">募集停止</span>
                    <i className="fas fa-arrow-right"></i>
                </button>
            ))}
        </div>
    )
}

export default RecruitLink;
